export default __webpack_public_path__ + "static/media/pink-umbrella.9889a9b8.png";